import $apiJSON from 'http/apiJSON'

const BASE = '/distance'

export const myDistance = () => $apiJSON.get(`${BASE}/me/`)

export const listLectures = (params = {}) => $apiJSON.get(`${BASE}/lectures/`, { params })
export const getLecture = (id) => $apiJSON.get(`${BASE}/lectures/${id}/`)
export const createLecture = (fd) =>
  $apiJSON.post(`${BASE}/lectures/`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
export const deleteLecture = (id) => $apiJSON.delete(`${BASE}/lectures/${id}/`)
export const trackView = (id) => $apiJSON.post(`${BASE}/lectures/${id}/view/`, {})

export const listClassrooms = (params = {}) =>
  $apiJSON.get(`${BASE}/classrooms/`, { params })
export const upcomingClassrooms = (params = {}) =>
  $apiJSON.get(`${BASE}/classrooms/upcoming/`, { params })
export const getClassroom = (id) => $apiJSON.get(`${BASE}/classrooms/${id}/`)
export const createClassroom = (payload) =>
  $apiJSON.post(`${BASE}/classrooms/`, payload)
export const updateClassroom = (id, payload) =>
  $apiJSON.patch(`${BASE}/classrooms/${id}/`, payload)
export const joinClassroom = (id) => $apiJSON.get(`${BASE}/classrooms/${id}/join/`)

export const listVirtual = (params = {}) => $apiJSON.get(`${BASE}/classrooms/`, { params })
export const getVirtual = (id) => $apiJSON.get(`${BASE}/classrooms/${id}/`)
export const createVirtual = (payload) => $apiJSON.post(`${BASE}/classrooms/`, payload)
export const updateVirtual = (id, payload) => $apiJSON.patch(`${BASE}/classrooms/${id}/`, payload)
export const joinVirtual = (id) => $apiJSON.get(`${BASE}/classrooms/${id}/join/`)

export default {
  myDistance,
  listLectures,
  getLecture,
  createLecture,
  deleteLecture,
  trackView,
  listClassrooms,
  upcomingClassrooms,
  getClassroom,
  createClassroom,
  updateClassroom,
  joinClassroom,
  listVirtual,
  getVirtual,
  createVirtual,
  updateVirtual,
  joinVirtual,
}
